import React from 'react';

const Back = () => {
    return (
        <svg width={34} height={34} viewBox="0 0 34 34">
            <g transform="translate(-1 -1)">
                <circle
                    cx={16}
                    cy={16}
                    r={16}
                    transform="translate(2 2)"
                    stroke="#FFF"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                />
                <path
                    d="M18 11.6L11.6 18l6.4 6.4M24 18H12"
                    stroke="#FFF"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                />
            </g>
        </svg>
    );
};

export default Back;
